import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Edit1"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M3.91952 9.7838C3.99302 9.8173 4.06002 9.8643 4.11752 9.92229L5.95752 11.7813C6.0344 11.8596 6.09142 11.9551 6.12381 12.0599C6.15619 12.1648 6.163 12.2758 6.14366 12.3838C6.12433 12.4918 6.07941 12.5936 6.01266 12.6807C5.94591 12.7677 5.85928 12.8376 5.76002 12.8843L2.38152 14.4383C2.04152 14.5943 1.64152 14.4433 1.48652 14.1003C1.44648 14.0114 1.42578 13.915 1.42578 13.8175C1.42578 13.7201 1.44648 13.6237 1.48652 13.5348L3.02502 10.1218C3.06117 10.0405 3.1131 9.96715 3.1778 9.90606C3.2425 9.84496 3.31868 9.79731 3.40193 9.76587C3.48518 9.73444 3.57384 9.71983 3.66277 9.72291C3.7517 9.72598 3.83914 9.74668 3.92002 9.7838H3.91952ZM12.4445 1.69979L14.355 3.62979C14.4817 3.75833 14.5527 3.93156 14.5527 4.11204C14.5527 4.29252 14.4817 4.46575 14.355 4.59429L7.66852 11.3483C7.60614 11.4116 7.5318 11.4618 7.44983 11.4961C7.36785 11.5304 7.27988 11.5481 7.19102 11.5481C7.10216 11.5481 7.01419 11.5304 6.93221 11.4961C6.85024 11.4618 6.7759 11.4116 6.71352 11.3483L4.80252 9.41829C4.67568 9.28973 4.60456 9.1164 4.60456 8.93579C4.60456 8.75519 4.67568 8.58186 4.80252 8.45329L11.4895 1.69979C11.5519 1.63651 11.6262 1.58626 11.7082 1.55196C11.7902 1.51766 11.8782 1.5 11.967 1.5C12.0559 1.5 12.1439 1.51766 12.2258 1.55196C12.3078 1.58626 12.3821 1.63651 12.4445 1.69979Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var edit1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { edit1 as default };
